import { unitList } from "constants/unit";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

//get all unit listing
export const getUnitListing = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_unit_listing(pageNum, filters);
    dispatch({ type: unitList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: unitList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

//add unit
export const addUnit = async (bodyData) => {
  try {
    const res = await api.add_unit(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//edit unit
export const editUnit = async (id, bodyData) => {
  try {
    const res = await api.edit_unit(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//get details
export const getUnitDetailsById = async (id) => {
  try {
    const res = await api.get_unit_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//delete unit
export const deleteUnit = async (id) => {
  try {
    const res = await api.delete_unit_by_Id(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
